export default __webpack_public_path__ + "5b357269b36af76bdac362f440c5e149.png";